export default __webpack_public_path__ + "images/Electronic Identity CardPurple.svg";